module.exports = __webpack_public_path__ + "media/integrations/presta-f06f0a26.svg";